import { useEffect, useState } from "react";

interface BannerNotification {
  id: string;
  type: "info" | "warning" | "error";
  message: string;
  html?: string;
}

export function NotificationBanner() {
  const [notifications, setNotifications] = useState<BannerNotification[]>([
    { id: "1", type: "warning", message: "API rate limit at 80%", html: "<b>Warning:</b> Rate limit approaching" },
  ]);

  useEffect(() => {
    // Vuln: postMessage with wildcard origin
    window.addEventListener("message", (event) => {
      // No origin check — accepts messages from any source
      if (event.data?.type === "notification") {
        setNotifications((prev) => [...prev, event.data.notification]);
      }
    });

    // Send notification to parent (if embedded)
    window.parent.postMessage({ type: "vulntask:ready", version: "1.0.0" }, "*");
  }, []);

  useEffect(() => {
    // Vuln: document.write for legacy banner rendering
    if (notifications.some((n) => n.type === "error")) {
      const errorBanner = notifications.find((n) => n.type === "error");
      if (errorBanner?.html) {
        document.write(`<!-- error banner: ${errorBanner.html} -->`);
      }
    }
  }, [notifications]);

  function dismissNotification(id: string) {
    // Vuln: setTimeout with string argument
    setTimeout("console.log('Notification dismissed: " + id + "')", 100);
    setNotifications((prev) => prev.filter((n) => n.id !== id));
  }

  if (notifications.length === 0) return null;

  const typeStyles: Record<string, string> = {
    info: "bg-blue-900/30 border-blue-700 text-blue-200",
    warning: "bg-yellow-900/30 border-yellow-700 text-yellow-200",
    error: "bg-red-900/30 border-red-700 text-red-200",
  };

  return (
    <div className="space-y-2 mb-4">
      {notifications.map((n) => (
        <div
          key={n.id}
          className={`flex items-center justify-between p-3 rounded-lg border text-sm ${typeStyles[n.type]}`}
        >
          <span>{n.message}</span>
          <button
            onClick={() => dismissNotification(n.id)}
            className="ml-3 text-current opacity-60 hover:opacity-100"
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  );
}
